import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import AboutSection from '@/pages/home/components/AboutSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import IndexSection from '@/pages/home/components/IndexSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AppSection from '@/pages/home/components/AppSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <TopicsSection />
        <MediaSection />
        <IndexSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <FaqSection />
        <CarouselSection />
        <AppSection />
        <FeaturesSection />
      </main>

      <Footer />
    </>
  );
}